import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'pt-remove-box',
  templateUrl: './remove-box.component.html',
  styleUrls: ['./remove-box.component.scss']
})
export class RemoveBoxComponent {

  @Input() title: string;
  @Input() description: string;

  @Output() confirmedDelete = new EventEmitter();

}
